import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Params } from '@/utils/types';
import { useNavigate, useSearchParams } from 'react-router';

export type PageSizeProps = {
	pageSize: string;
	options: string[];
};

export const PageSize = ({ pageSize, options }: PageSizeProps) => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const handlePageSizeChange = (value: string) => {
		const newSearchParams = new URLSearchParams(searchParams.toString());
		newSearchParams.set(Params.page, '1');
		newSearchParams.set(Params.pageSize, value);

		navigate(`?${newSearchParams.toString()}`);
	};

	return (
		<div className="flex justify-center items-center gap-2">
			<p className="text-sm">Rows per page</p>

			<Select value={pageSize} onValueChange={handlePageSizeChange}>
				<SelectTrigger className="w-20" aria-label="pageSize">
					<SelectValue placeholder="Rows per page" />
				</SelectTrigger>
				<SelectContent>
					{options.map(option => (
						<SelectItem key={option} value={option}>
							{option}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};
